import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { organizationsKeys } from 'utils/query-keys'

interface IntegrationConnectionSettings {
  id?: number
  create_new_contacts?: boolean
  two_way_sync?: boolean
  log_against_deals?: boolean
  sync_call_recordings?: boolean
  sync_outgoing_answered_calls?: boolean
  sync_outgoing_unanswered_calls?: boolean
  sync_incoming_answered_calls?: boolean
  sync_incoming_missed_calls?: boolean
  sync_outgoing_voicemails?: boolean
  sync_incoming_sms?: boolean
  sync_outgoing_sms?: boolean
  sync_contacts?: boolean
  sync_calls?: boolean
  sync_messages?: boolean
  sync_email_messages?: boolean
  sync_email_open_events?: boolean
  sync_contact_notes?: boolean
  last_sync_at?: string
  zapier_api_key?: string
  webhook_url?: string
}

interface ConfiguredIntegration {
  id: number
  name: string
  type: string
  status: string
  enabled: boolean
  connected_at: string
  // GHL-specific fields
  ghl_company_id?: string
  ghl_location_id?: string
  state?: string
  version?: number
  sync_as_lead?: boolean
  // General integration fields
  webhook_url?: string
  instance_url?: string
  portal_id?: string
  tenant?: string
  // Integration connection settings
  settings?: IntegrationConnectionSettings
}

interface OrganizationIntegrationsResponse {
  data: {
    organization_id: number
    organization_name: string
    integrations: ConfiguredIntegration[]
  }
}

const fetchOrganizationIntegrations = async (orgId: string) => {
  try {
    let response = await fetch(
      `${BASE_API_URL}/admin/api/v2/organizations/${orgId}/integrations`,
      {
        method: API_METHODS.GET,
        headers: apiHeaders(store.getState()),
      }
    )
    response = handleErrors(response)
    const json: OrganizationIntegrationsResponse = await response.json()
    return json.data
  } catch (error) {
    console.error('error', error)
  }
}

export const useOrganizationIntegrations = (orgId: string) => {
  return useQuery(
    organizationsKeys.integrations(orgId),
    () => fetchOrganizationIntegrations(orgId),
    {
      enabled: !!orgId,
    }
  )
}
